import { helper as buildHelper } from "@ember/component/helper"
import _ from "lodash"

export function joinWords(params /*, hash*/) {
  var array = params[0] || []
  var size = _.size(array)
  var result = ""
  switch (size) {
    case 0:
      break
    case 1:
      result = _.first(array)
      break
    case 2:
      result = _.first(array) + " and " + _.last(array)
      break
    default:
      result = _.reduce(
        array,
        (acc, el, index) => {
          if (index === 0) {
            return acc + el
          } else if (index + 1 === size) {
            return acc + ", and " + el
          } else {
            return acc + ", " + el
          }
        },
        ""
      )
      break
  }
  return result
}

export default buildHelper(joinWords)
